import React from 'react';
import { Link } from 'react-router-dom';
import PRODUCTS from '../data/products';
import ProductList from '../components/ProductList/ProductList';
import PromoBanner from '../components/PromoBanner/PromoBanner';
//import './Home.css';

export default function Home({ onAddToCart }) {
  const featured = PRODUCTS.slice(0, 3);

  return (
    <div className="page home-page">
      {/* Site-wide promo banner */}
      <PromoBanner text='Deal of the Day: 20% off MacBook Pro 14"! Use code MAC20 at checkout.' />

      <h1>Welcome to Antipas Electronics</h1>
      <p>Check out our top picks:</p>
      <ProductList products={featured} onAddToCart={onAddToCart} />
      <p>
        <Link to="/catalog">Browse all products →</Link>
      </p>
    </div>
  );
}
